import { httpsCallable } from "../serverUtils"
import type { CreateManyAnalyticsEventsRequest } from "./types.js"

export const createAnalyticsEvents =
  httpsCallable<CreateManyAnalyticsEventsRequest>("analyticsEvents", {
    authNotRequired: true,
  })
